import Marquee from "react-fast-marquee";
import { MapPin } from "@phosphor-icons/react";
import Reveal from "@/components/site/Reveal";
import { AREAS, IMAGES } from "@/lib/siteData";

export default function ServiceArea() {
  return (
    <section id="service-area" data-testid="service-area-section" className="relative py-24 lg:py-32 bg-surface border-y border-line overflow-hidden">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="grid lg:grid-cols-2 gap-14 items-center">
          <div>
            <Reveal>
              <p className="text-xs uppercase tracking-[0.3em] text-gold mb-5">Service Area</p>
            </Reveal>
            <Reveal delay={0.05}>
              <h2 className="font-heading font-bold tracking-tight text-white text-4xl sm:text-5xl leading-[1.05]">
                Proudly serving the greater San Antonio area.
              </h2>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="mt-7 text-base sm:text-lg text-white/70 leading-relaxed max-w-xl">
                B3 Contracting LLC serves homeowners and businesses in Schertz, New Braunfels, San
                Antonio and surrounding communities.
              </p>
            </Reveal>
          </div>

          <Reveal delay={0.1}>
            <div className="relative">
              <div className="absolute -inset-3 border border-line" aria-hidden="true" />
              <img
                src={IMAGES.area}
                alt="San Antonio, Texas skyline"
                className="relative w-full h-[320px] lg:h-[380px] object-cover grayscale hover:grayscale-0 transition-[filter] duration-700"
              />
            </div>
          </Reveal>
        </div>
      </div>

      <div className="mt-16 marquee-fade">
        <Marquee speed={40} gradient={false} pauseOnHover>
          {AREAS.map((a) => (
            <span
              key={a}
              data-testid={`area-${a.toLowerCase().replace(/\s/g, "-")}`}
              className="mx-8 inline-flex items-center gap-3 font-heading font-medium text-4xl sm:text-6xl tracking-tight text-white/25"
            >
              <MapPin size={28} weight="fill" className="text-gold" />
              {a}
            </span>
          ))}
        </Marquee>
      </div>
    </section>
  );
}
